import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'TiposCambio';

export interface TipoCambio {
  CountryName: string;
  CurrencyISO: string;
  CurrencyName: string;
  AverageRate: number
  ClosingRate: number;
  EstimatedAverageRate: number;
  Source: string
}

export class TiposCambioAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarTiposCambio(año:number, mes: number): AxiosPromise<TipoCambio[]> {
		return this.cliente.get(`/ListarTiposCambio/${año}/${mes}`);
	}
}